import { type RegionName, resolveLocationPagesToLocationCardGroups, type LocationCardGroup } from './locationCardGroupResolver';
import { type LocationListingQuery } from 'cms/cms';
import { type LocationPage, type LocationPageItems, resolveLocationPagesToMapItems } from './mapItemResolver';
import { type LocationMapItem } from '4-sections/FilteredListings/MapAndListing/Map/ListingMap';
import { type LocationCardResolverSettings } from './locationCardResolver';

interface LocationListingData {
    total: number;
    cardGroups: LocationCardGroup[];
    mapItems: LocationMapItem[];
}

export const locationCardDefaultSettings = {
    emailLabel: 'Email',
    telLabel: 'Tel',
};

export const resolveLocationListing = (data: LocationListingQuery, settings: LocationCardResolverSettings = locationCardDefaultSettings): LocationListingData | null => {
    const { items, total, facets } = data.LocationPage as LocationPage;

    const regionNames = facets?.RegionCategories?.Name || [];
    const regionDescriptions = facets?.RegionCategories?.Description || [];
    const combinedRegions = regionNames.map((nameObj, index) => {
        return {
            ...nameObj,
            description: regionDescriptions?.[index]?.name || nameObj?.name,
        };
    });

    return {
        total: Number(total),
        cardGroups: resolveLocationPagesToLocationCardGroups(items as LocationPageItems, combinedRegions as RegionName[]),
        mapItems: resolveLocationPagesToMapItems(items as LocationPageItems, settings),
    };
};
